import { menuSelect } from 'instantsearch.js/es/widgets'

/**
 * Load the Menu Select widgets.
 *
 * @param {Element} mainContainer The main search container.
 * @returns {Array} The stats widgets.
 */
export default function menuSelectWidgets( mainContainer ) {
  const widgets = []

  Array.from( mainContainer.querySelectorAll( '.js-instant-search-menu-select' ) ).forEach(
    element => {
      widgets.push(
        menuSelect({
          container: element,
          attribute: element.dataset.attribute,
          sortBy: ['name:asc'],
          limit: 100,
          templates: {
            defaultOption: element.dataset.seeAllText,
          },
        })
      )
    })

  return widgets
}
